// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EVxL","footer":"styles_footer__2nfxs"};